import React from"react";
import {
 ArrowDownTrayIcon,
 ArrowsPointingOutIcon,
 PhotoIcon,
 SparklesIcon,
} from"@heroicons/react/24/outline";

const VisualizationPreview = ({
 imageUrl,
 loading,
 taskTitle,
 hint,
 generatedAt,
 downloadFileName ="visualization.png",
}) => {
 const handleOpen = () => {
 if (!imageUrl) return;
 window.open(imageUrl,"_blank");
 };

 const handleDownload = () => {
 if (!imageUrl) return;
 const link = document.createElement("a");
 link.href = imageUrl;
 link.download = downloadFileName;
 link.click();
 };

 return (
 <div className="mt-6 rounded-2xl border border-secondary/30 bg-gradient-to-br from-[#050d1f] via-[#0a142b] to-[#0f1f3f] p-5 shadow-[0_15px_50px_rgba(12,18,41,0.45)]">
 <div className="flex flex-wrap items-start justify-between gap-4">
 <div>
 <p className="text-xs uppercase tracking-[0.3em] text-primary/80">
 AI Visualization Studio
 </p>
 <h4 className="text-xl font-semibold text-white mt-1">
 {taskTitle ||"Visualization Preview"}
 </h4>
 {hint ? (
 <p className="text-sm text-muted mt-1 line-clamp-2">
 {hint}
 </p>
 ) : (
 <p className="text-sm text-gray-500 mt-1">
 Photorealistic walkthroughs of your architecture, generated by
 SkillGenie Vision.
 </p>
 )}
 </div>
 <div className="text-right">
 <div className="inline-flex items-center gap-1 text-xs px-3 py-1 rounded-full bg-primary/10 text-primary border border-primary/30">
 <SparklesIcon className="h-4 w-4" />
 <span>Cinematic Realism</span>
 </div>
 {generatedAt && (
 <p className="text-[11px] text-gray-500 mt-1">
 Updated {generatedAt.toLocaleString()}
 </p>
 )}
 </div>
 </div>

 <div className="mt-4 relative aspect-[16/9] rounded-2xl overflow-hidden border border-accentGray/50 bg-gradient-to-br from-[#030712] to-[#0f172a]">
 {loading ? (
 <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 text-muted">
 <div className="w-16 h-16 rounded-full border-2 border-primary/40 border-t-transparent animate-spin" />
 <p className="text-sm text-primary">Rendering photorealistic scene…</p>
 </div>
 ) : imageUrl ? (
 <img
 src={imageUrl}
 alt="AI Generated Visualization"
 className="h-full w-full object-cover"
 loading="lazy"
 />
 ) : (
 <div className="absolute inset-0 flex flex-col items-center justify-center text-gray-500 gap-3">
 <PhotoIcon className="h-12 w-12 text-gray-600" />
 <p className="text-sm text-muted text-center px-6">
 Generate a visualization to see a cinematic preview of your solution.
 </p>
 </div>
 )}
 <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-4 flex items-center justify-between">
 <div className="text-sm text-white/90 font-medium">
 {imageUrl ?"Rendered Output" :"Awaiting generation"}
 </div>
 <div className="flex gap-2">
 <button
 onClick={handleOpen}
 disabled={!imageUrl}
 className="inline-flex items-center gap-1 text-xs font-semibold px-3 py-1.5 rounded-full bg-white/10 text-white hover:bg-white/20 disabled:opacity-40"
 >
 <ArrowsPointingOutIcon className="h-4 w-4" />
 Open
 </button>
 <button
 onClick={handleDownload}
 disabled={!imageUrl}
 className="inline-flex items-center gap-1 text-xs font-semibold px-3 py-1.5 rounded-full bg-primary text-white hover:bg-primary disabled:opacity-40"
 >
 <ArrowDownTrayIcon className="h-4 w-4" />
 Download
 </button>
 </div>
 </div>
 </div>
 </div>
 );
};

export default VisualizationPreview;




